<template>
  <div class="flex flex-col items-center w-full h-full">
    <NuxtImg
      width="150"
      height="150"
      loading="lazy"
      :src="card.image"
      class="levitation"
      :style="{ animationDelay: card.id + 's' }"
      :alt="card.name"
    />
    <h3 class="local-title">
      {{ card.name }}
    </h3>
    <p class="card-description content-text">
      {{ card.description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ContentSectionTwoCard',
  props: {
    card: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="scss" scoped>
.local-title {
  margin-top: 32px;
  margin-bottom: 20px;
}

.card-description {
  border: 1px $yellow-100 dashed;
  border-radius: 16px;
  padding: 16px;
  height: 100%;
}
</style>
